// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.languageList {
    width: 20em;
    border: 1px solid #D5D5D5;
    border-radius: 3px;
}

.listbox-item-content {
    padding-left: 5px!important;
}

.searchBox {
    padding: 0px 0px 5px 5px;
    margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/general/general.settings.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB","sourcesContent":[".languageList {\n    width: 20em;\n    border: 1px solid #D5D5D5;\n    border-radius: 3px;\n}\n\n.listbox-item-content {\n    padding-left: 5px!important;\n}\n\n.searchBox {\n    padding: 0px 0px 5px 5px;\n    margin-bottom: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
